// @core/api/endpoints/audittrail/get_retention_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetentionPolicyResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Get retention policy
 * Retrieves a retention policy by its unique identifier.
 */
export async function GetRetentionPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<RetentionPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/retention-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<RetentionPolicyResponse>(requestPath, { ...requestOptions });
}
